import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/** Contractul lui GET /api/v2/shell/todo (v4/api, App\Shell\Todo\HeaderTodo). */

/** `unknown` = randul "Unassigned devices" (cheia a ramas din contractul de la inceput). */
export type TodoKey = 'offices' | 'unknown' | 'apps' | 'expiring' | 'discovery'

export interface TodoItem {
  key: TodoKey
  count: number
  /** Numai la `offices`: firma a carei fila Offices se deschide. */
  companyId?: number
}

export interface ShellTodo {
  /** Suma randurilor. */
  total: number
  /**
   * Firma numarata: NUMAI cea aleasa sus in bara, si cu "All companies".
   * 0 = nicio firma aleasa, sau una la care omul n-are acces - nu se numara nimic.
   */
  company?: number
  /** Numai categoriile cu ceva in ele si pe care omul le poate rezolva. */
  items: TodoItem[]
}

export const shellTodoQuery = queryOptions({
  queryKey: ['shell', 'todo'],
  queryFn: () => apiGet<ShellTodo>('/shell/todo'),
  staleTime: 60_000,
  refetchInterval: 5 * 60_000,
})
